/* eslint-disable jsx-a11y/label-has-for */
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import styles from './Label.module.scss'

export default function Label({ children, className, hidden, htmlFor }: props) {
  return (
    <label
      htmlFor={htmlFor}
      className={classNames('Label', 'uk-form-label', styles.this, hidden && styles['this---hidden'], className)}>
      {children}
    </label>
  )
}

Label.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  //element: PropTypes.oneOf(['h3', 'label']),
  hidden: PropTypes.bool,
  //htmlFor: PropTypes.string.isRequired,
  htmlFor: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/Label/Label.js